import { GENERAL_TABS_ACTIVE_TAB, GENERAL_TABS_REMOVE_DATA } from './constants'

export function activeTab(id, index) {
    return {
        type: GENERAL_TABS_ACTIVE_TAB,
        data: {
            id,
            index,
        },
    }
}

export function removeData(id) {
    return {
        type: GENERAL_TABS_REMOVE_DATA,
        data: {
            id,
        },
    }
}
